import script from "./FormLocationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLocationComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormLocationComponent.vue?vue&type=style&index=0&id=b97b6478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b97b6478"]])

export default __exports__